import styled from 'styled-components';

export const Footer = styled.div`
    height: 10%;
    width: 100%;
    display: flex;
    flex-direction: column:
    justify-content: center;
    align-items: center;
`;